export function LegalBasis() {
  return (
    <p>
      Art. 6(1) lit. a GDPR serves as the legal basis for processing operations for which we obtain consent for a specific processing purpose. You may indicate your consent in a number of ways, including, as permitted by law, ticking a box (or equivalent action) to indicate your consent when (i) providing us with your Personal Data through our services or a form (including enrolling in Promotions); or (ii) registering or creating a member account with us.
    </p>
  );
}

export default LegalBasis;
